export enum MenuChange {
	MenuItemChange = 'Menu Change',
	MenuBetaItemChange = 'Beta Menu Change',
}
